export const Storage = {
  userKey: 'userKey',
  platform: 'platform',
  comefrom: 'comefrom',
  downloadPlatform: 'downloadPlatform',
  downloadBusinessPlatform: 'downloadBusinessPlatform',
  fingerprint: 'fingerprint', // 浏览器指纹
  comefromTime: 'comefromTime', // 记录来源链接过期时间
}
